module.exports = __webpack_public_path__ + "static/media/brand-promotion-mobile.f57c58c9.jpg";